export default {
  state: {
    unassignDriver: {
      show: false,
      rsvp: null
    }
  },
  mutations: {
    showUnassignDriver (state) { state.unassignDriver.show = true },
    hideUnassignDriver (state) { state.unassignDriver.show = false },
    setUnassignRsvp (state, value) { state.unassignDriver.rsvp = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/unassign-driver.js